import JsonApi from 'devour-client';

declare global {
  interface Window {
    JsonApi: typeof JsonApi;
  }
}

window.JsonApi = JsonApi;
